import e from "../button/Button.js";
import { getTrackingLabelFromNode as t } from "../../utils/analytics/getTrackingLabelFromNode.js";
import { noop as n } from "es-toolkit/function";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/sidebars/SidebarCloseButton.tsx
var i = ({ title: i, onClick: a = n }) => {
	let o = t(i);
	return /* @__PURE__ */ r(e, {
		bsStyle: e.MUTED,
		iconOnly: !0,
		onClick: a,
		autoTrackingKey: o && `sidebar::closed::${o}`,
		"data-testid": "sidebarCloseButton",
		children: /* @__PURE__ */ r("span", { className: "uikit-icon icon-remove" })
	});
};
//#endregion
export { i as default };

//# sourceMappingURL=SidebarCloseButton.js.map